export default __webpack_public_path__ + "static/media/cliente-persona.b5e301a6.png";